/**
 * ============================================================================
 * SideButtons (MVC feature barrel)
 * ============================================================================
 * Public entry kept at index.tsx so layout-dynamic import stays stable:
 *   import("@/components/atoms/SideButtons")
 * ============================================================================
 */
"use client";

import { SectionErrorBoundary } from "@/components/common/ErrorBoundary";
import { useSideButtonsController } from "./controller/useSideButtonsController";
import SideButtonsView from "./view/SideButtonsView";
import type { SideButtonsProps } from "./model/sideButtons.types";

export type {
  SideButtonsProps,
  SideButtonsViewModel,
} from "./model/sideButtons.types";

function SideButtonsInner(props: SideButtonsProps) {
  const viewModel = useSideButtonsController(props);
  return <SideButtonsView {...viewModel} />;
}

export default function SideButtons(props: SideButtonsProps) {
  return (
    <SectionErrorBoundary sectionName="SideButtons">
      <SideButtonsInner {...props} />
    </SectionErrorBoundary>
  );
}
